<!--
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-19 14:38:00
-->
<template>
  <viewFile :wpsUrl="jwpsUrl" :token="jtoken" />
</template>
<script>
import viewFile from '@/components/File/wps';
export default {
  data() {
    return {
      jwpsUrl: '',
      jtoken: ''
    }
  },
  created() {
    this.jwpsUrl = sessionStorage.wpsUrl;
    this.jtoken = sessionStorage.token;
  },
  // 通过组件渲染wps的 iframe 框架
  components: {
    viewFile
  }
}
</script>
